import { Component, Input, OnInit, signal, inject } from '@angular/core';
import { AppModeService } from '../../../services/app-mode.service';
import { LogoutService } from 'src/services/logout.service';
import { AuthLinksService } from 'src/services/auth-links.service';
import { DashboardRoute, FaqRoute } from 'src/models/routes.model';
import { PhoneNativeService } from 'src/services/phone-native.service';

@Component({
  selector: 'liberro-basic-layout-header',
  standalone: false,
  templateUrl: './basic-layout-header.component.html',
  styleUrl: './basic-layout-header.component.less',
})
export class BasicLayoutHeaderComponent implements OnInit {
  private appModeService = inject(AppModeService);
  private lougoutService = inject(LogoutService);
  private authLinksService = inject(AuthLinksService);
  private phoneNativeService = inject(PhoneNativeService);

  public dashboardRoute = `/${DashboardRoute.DASHBOARD}`;
  public needHelpLink = `/${FaqRoute.FAQ}`;
  public actionBtnKey = signal<string>('');
  public actionBtnShape = signal<'round' | null>(null);
  // ng-zorro dropdown
  public desktopHamburgerMenuOpened = signal<boolean>(false);
  // full-screen overlay
  public mobileHamburgerMenuOpened = signal<boolean>(false);

  @Input() public authenticatedHeader = false;
  @Input() public showHeaderHamburger = false;
  @Input() public showHeaderLinks = false;
  @Input() public headerBackground: 'filled' | 'transparent' = 'filled';
  @Input() public isLoginUrl = false;
  @Input() public onlyLogoHeader = false;
  @Input() public previewOnlyHeaderText = false;

  // prevent main content scrollbar to be active when mobile hamburger overlay panel is active

  public onHamburgerPanelVisibilityChange(visible: boolean): void {
    this.desktopHamburgerMenuOpened.set(visible);
  }

  public toggleHamburgerMenu(): void {
    const next = !this.mobileHamburgerMenuOpened();
    this.mobileHamburgerMenuOpened.set(next);
    this.phoneNativeService.setBodyScrollLocked(next);
  }

  public closeMobileHamburgerMenu(): void {
    this.mobileHamburgerMenuOpened.set(false);
    this.phoneNativeService.setBodyScrollLocked(false);
  }

  public get isTransparentHeader(): boolean {
    return this.headerBackground === 'transparent';
  }

  public logout(): void {
    this.lougoutService.logOut();
  }

  public get workplaceLoginUrl(): string {
    return this.authLinksService.bcasConsultLoginUrl;
  }

  public ngOnInit(): void {
    this.actionBtnKey.set(
      this.appModeService.getAppModeValue(
        'global.button.home', 'global.button.endInteraction', ''
      ) as string
    );

    this.actionBtnShape.set(
      this.appModeService.getAppModeValue(
        null, 'round'
      )
    );
  }
}
